import { memo, useMemo } from "react";
import { Loader } from "react-better-html";

import { company } from "../../constants/company";
import { legal } from "../../constants/legal";

import { type Language } from "../../types/i18n";

import { useI18n } from "../../utils/i18n";

import Markdown from "../../components/common/Markdown";

type SingleLegalDocumentProps = {
   document: keyof typeof legal;
};

function SingleLegalDocument({ document }: SingleLegalDocumentProps) {
   const { language } = useI18n();

   const content = useMemo<string>(() => {
      const readyLanguage = language as Language;

      const placeholders: Record<string, string> = {
         companyName: company.name,
         domain: company.domain.replace("https://", ""),
         url: company.domain,
         legalName: company.legalName[readyLanguage],
         contactEmail: company.contactEmail,
         address1: company.address1[readyLanguage],
         address2: company.address2[readyLanguage],
         uic: company.uic,
         vatNumber: company.vatNumber,
         registeredAddress: `${company.address1[readyLanguage]}, ${company.address2[readyLanguage]}`,
         ppUrl: "/legal/privacy-policy",
         tcUrl: "/legal/terms-and-conditions",
         dpaUrl: "/legal/data-processing-agreement",
      };

      return Object.entries(placeholders).reduce(
         (result, [key, value]) => result.replaceAll(`{{${key}}}`, value),
         legal[document][language as Language].body,
      );
   }, [language, document]);

   return <>{content ? <Markdown>{content}</Markdown> : <Loader.box />}</>;
}

export default memo(SingleLegalDocument);
